<template>
    <div @mouseleave="mouc">
        <template v-if="currentPath == '/home'">
            <div style="position: relative;width: 100%;">
                <div class="top-0 left-0 right-0 z-50 absolute" style="height:80px;width: 100%;">
                    <div class="mx-auto h-full flex items-center" style="width:1300px;justify-content:space-between;">
                        <div class="flex items-center" v-if="$isxj">
                            <a href="#" onclick="return false" class="flex items-center">
                                <img style="height: 50px;width: 168.5px;" :src="logob" :alt="siteConfig.title" />
                                <span class="ml-2 text-2xl hidden sm:block text-shuhei text-primary cprimary font-bold"
                                    style="font-size: 25px;color:#fff;"><span
                                        style="font-size: 22px;font-weight: 200;position: relative;top: -2px;color: #868686;margin: 0px 2px;">|</span>
                                    腾讯授权服务商</span>
                            </a>
                        </div>
                        <div v-else style="">
                            <img style="width: 400px;" :src="logoc" :alt="siteConfig.title" />
                        </div>
                        <div style="display: flex;align-items: center;">
                            <nav>
                                <ul class="flex" @mouseenter="istrue = false" @mouseleave="istrue = true">
                                    <template v-for="(item, i) in navItems">
                                        <li class="header-li-item" :class="{ 'asdzxcas': bindex == i }"
                                            style="height: 80px;">
                                            <a class="clickbutton" style="color:#fff;" @click="to(item.href)"
                                                @mouseenter="mou(i)" @mouseleave="bindex = -1" :class="`header-nav-item ${currentPath === item.href ? 'active' : ''
                                                    }`">
                                                {{ item.text }}
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="currentPath != '/home'">
            <div style="height:80px;"></div>
            <div style="position: relative;width: 100%;">
                <div class="top-0 left-0 right-0 z-50 bg-white shadow-md fixed" style="height:80px;width: 100%;">
                    <!-- :class="{ 'containerb': currentPath != '/home' }" -->
                    <div class="mx-auto h-full flex items-center" style="width:1300px;justify-content:space-between;">
                        <div class="flex items-center" v-if="$isxj">
                            <a href="#" onclick="return false" class="flex items-center">
                                <img style="height: 50px;width: 168.5px;" :src="logo" :alt="siteConfig.title" />
                                <span class="ml-2 text-2xl hidden sm:block text-shuhei text-primary cprimary font-bold"
                                    style="font-size: 25px;"><span
                                        style="font-size: 22px;font-weight: 200;position: relative;top: -2px;color: #868686;margin: 0px 2px;">|</span>
                                    腾讯授权服务商</span>
                            </a>
                        </div>
                        <div v-else style="">
                            <img style="width: 400px;" :src="logod" :alt="siteConfig.title" />
                        </div>
                        <div style="display: flex;align-items: center;">
                            <nav>
                                <ul class="flex" @mouseenter="istrue = false" @mouseleave="istrue = true">
                                    <template v-for="(item, i) in navItems">
                                        <li class="header-li-item" :class="{ 'asdzxcas': bindex == i }"
                                            :style="'height: 80px;border-bottom: ' + ((currentPath == item.href && istrue && bindex == -1) ? 3 : 0) + 'px solid #1e66d1;'">
                                            <a class="clickbutton" @click="to(item.href)" @mouseenter="mou(i)"
                                                @mouseleave="bindex = -1" :class="`header-nav-item ${currentPath === item.href ? 'active' : ''
                                                    }`">
                                                {{ item.text }}
                                            </a>
                                        </li>
                                    </template>
                                </ul>
                            </nav>
                            <!-- <div style="display: flex;justify-items: center;margin-left: 20px;" v-if="currentPath == '/home'">
                            <div style="width: 150px;height: 36px;font-size: 16px;background: #fff;border-radius: 50px;display: flex;align-items: center;justify-content: center;cursor: pointer;">
                            <div><img src="../assets/logo/dianhua.png" style="height: 20px;"></div>
                            <div>027-67536585</div>
                        </div>
                            <div @click="to('/contactForm')"
                                style="width: 90px;height: 36px;color: #fff;font-size: 16px;background: #f18500;border-radius: 50px;text-align: center;line-height: 36px;margin-left: 10px;cursor: pointer;">
                                联系我们</div>
                        </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <!--  -->
        <transition name="asdzxc">
            <div id="hmenu"
                v-if="navItems[1].isshow || navItems[2].isshow || navItems[3].isshow || navItems[4].isshow || navItems[5].isshow"
                style="background: #fff;position: fixed;top: 80px;width: 100%;z-index: 999999;box-shadow:rgb(140 139 139 / 50%) 0px 8px 9px 2px;"
                :style="currentPath != '/home' ? 'border-top: 1px solid #cccccc;' : ''">
                <div style="width: 1200px;margin: 0px auto;">
                    <div v-if="navItems[1].isshow" @mouseenter="mou(1)" @mouseleave="moub(1)"
                        style="display: flex;justify-content: space-around;flex-wrap: wrap;padding:50px 0px;">
                        <div @click="tob('AIMenu', x.title)" v-for="(x, i) in AImenus"
                            style="margin:10px 0px;width: 240px;display: flex;">
                            <div class="pmenu"
                                style="padding:10px 15px; cursor: pointer;border-radius: 10px;display: flex;align-items: center;">
                                <div><img style="height: 26px;width: 26px;" :src="x.icon"></div>
                                <div style="font-size: 14px;margin-left: 10px;">{{ x.title }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="navItems[2].isshow" @mouseenter="mou(2)" @mouseleave="moub(2)"
                        style="display: flex;justify-content: space-around;padding:25px 0px;">
                        <div v-for="x in pmenu" style="font-size: 14px;" v-if="x.name != '自研产品'">
                            <div
                                style="font-weight: bold;color: #333;margin-top: 10px;height: 20px;width: 158px;line-height: 20px;padding-left: 12px;border-left: 3px solid #1e66d1;margin-bottom: 20px;">
                                {{ x.name }}</div>
                            <div @click="tob('product', z.ID)" class="pmenu"
                                style="color: #666;margin-top: 10px;height: 36px;min-width: 140px;line-height: 36px;padding: 0px 15px;cursor: pointer;border-radius: 5px;"
                                v-for="z in x.children">{{ z.name }}</div>
                        </div>
                    </div>
                    <div v-if="navItems[3].isshow" @mouseenter="mou(3)" @mouseleave="moub(3)"
                        style="display: flex;justify-content: space-around;padding:25px 0px;">
                        <div v-for="x in apps" style="font-size: 14px;">
                            <div style="display: flex;align-items: center;margin-bottom: 0px;">
                                <div style="background: #35a9b1;border-radius: 10px;"><img
                                        style="height: 40px;width: 40px;" :src="action + x.logosrc"></div>
                                <div style="font-weight: bold;color: #333;margin-left: 20px;">
                                    {{ x.name }}
                                </div>
                            </div>
                            <div style="display: flex;flex-wrap: wrap;flex-direction: column;height: 330px;margin-left: 20px;"
                                :class="{ 'widthaaa': x.children.length > 7 }">
                                <div class="pmenu" @click="tob('app', z.ID)"
                                    style="color: #666;margin-top: 10px;height: 36px;line-height: 36px;margin-left:20px;padding: 0px 20px; cursor: pointer;border-radius: 5px;"
                                    v-for="z in x.children">{{ z.name }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="navItems[4].isshow" @mouseenter="mou(4)" @mouseleave="moub(4)"
                        style="display: flex;justify-content: left;flex-wrap: wrap;padding:50px 0px;width: 960px;margin: 0px auto;">
                        <div @click="tob('WorkBuddy', i)" v-for="(x, i) in WBmenus"
                            style="margin:10px 0px;width: 240px;display: flex;">
                            <div class="pmenu"
                                style="padding:10px 15px; cursor: pointer;border-radius: 10px;display: flex;align-items: center;">
                                <div><img style="height: 26px;width: 26px;" :src="x.icon"></div>
                                <div style="font-size: 14px;margin-left: 10px;">{{ x.title }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="navItems[5].isshow" @mouseenter="mou(5)" @mouseleave="moub(5)"
                        style="display: flex;justify-content: space-around;flex-wrap: wrap;padding:25px 0px;">
                        <div class="pmenu" @click="tob('solution', x.ID, i)" v-for="(x, i) in menus"
                            style="display: flex;align-items: center;margin:10px 0px;width: 260px;padding:10px 0px;padding-left:50px;cursor: pointer;border-radius: 10px;">
                            <div><img style="height: 22px;width: 22px;" :src="imgs[i]"></div>
                            <div style="font-size: 14px;margin-left: 10px;">{{ x.name }}行业解决方案</div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <keep-alive :exclude="'handlePrint'">
            <router-view />
        </keep-alive>
        <!-- :style="{ 'height': $isxj ? '160px' : '140px' }" -->
        <div class="bg-primary">
            <div class="relative" style="height: 160px;background: #29313f;">
                <!-- <img :src="siteConfig.footer.background" class="w-full h-full object-cover top-0 left-0 absolute"
                    alt="footer background" style="height: 180px;" /> -->
                <div class="relative text-white py-2">
                    <div class="containerb" style="margin: 0px auto;margin-top: 15px;">
                        <!-- <nav class="flex items-center flex-wrap py-4 px-4">
                            <span class="text-lg font-bold mr-4">产品</span>
                            <ul class="flex text-white/60" style="font-size: 14px;margin-left: 50px;">
                                <template v-for="(item, i) in list">
                                    <li class="mr-6">
                                        <a href="#" onclick="return false">{{ item }}</a>
                                    </li>
                                </template>
                            </ul>
                        </nav> -->
                        <!-- <div style="background: #666;height: 1px;" class="w-full bg-white/20 my-2"></div> -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 py-4">
                            <div>
                                <p class="text-2xl">
                                    {{ siteConfig.slogan }}
                                </p>
                                <div class="text-white bg-primary px-2 py-1 rounded-md text-xs mt-4 w-max bprimary">
                                    {{ siteConfig.subTitle }}
                                </div>
                            </div>
                            <div>
                                <div class="text-xl mb-4" style="font-size: 16px;font-weight: bold;">
                                    {{ siteConfig.title }}
                                </div>
                                <!-- :class="{ 'cyaddress': !$isxj }" -->
                                <p class="text-white/60 text-sm" style="opacity: 0.65;">
                                    {{ siteConfig.contact.address }}
                                </p>
                                <p class="text-white/60 text-sm"
                                    style="margin-bottom: 10px;margin-top: 16px;opacity: 0.65;">
                                    咨询电话：{{ siteConfig.contact.phone }}
                                </p>
                                <!-- <label @click="to('/contactForm')"
                                    style="font-size: 14px;color: #87898d;margin-top: 10px;border: 1px solid #87898d;padding:3px 10px;border-radius: 5px;cursor: pointer;">
                                    联系我们
                                </label> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full" style="background-color: #29313f;text-align: center;color: #87898d;">
                <div style="display: inline-block;font-size: 14px;height: 60px;line-height: 60px;color: #87898d;"
                    class="containerb flex items-center justify-center text-white flex-col md:flex-row">
                    <span class="mr-4">
                        {{ siteConfig.footer.copyright }}
                    </span>
                    <span class="mr-4">
                        <a onclick="return false" :href="siteConfig.footer.icpLink">{{ siteConfig.footer.icp }}</a>
                    </span>
                    <span>
                        <a onclick="return false" :href="siteConfig.footer.gajLink">{{ siteConfig.footer.gaj }}</a>
                    </span>
                </div>
            </div>
        </div>
        <!-- box-shadow: rgb(0 0 0 / 50%) -5px 5px 20px 1px; -->
        <!-- box-shadow: rgb(125 125 125 / 50%) -1px 0px 10px 0px; -->
        <div v-if="iskefu">
            <div v-if="ispc"
                style="position: fixed;right: 55px;bottom: 186px;z-index: 99999999;display: flex;align-items: center;border-radius: 5px;border: 2px solid rgb(241 241 241);padding: 20px 20px;background: #fff;">
                <div v-if="$isxj"><img src="../assets/home/kefu.png" style="width: 80px;"></div>
                <div v-else><img src="../assets/home/kefuc.png" style="width: 80px;"></div>
                <div style="margin-left: 20px;">
                    <div style="font-size: 18px;">微信扫码</div>
                    <div style="font-size: 14px;color: #999;margin-top: 5px;">联系企业微信客服</div>
                </div>
            </div>
            <div v-if="!ispc" :style="{ bottom: ispc ? '186px' : 'calc(50% - 114px)' }"
                style="position: fixed;right: 55px;z-index: 99999999;display: flex;align-items: center;border-radius: 5px;border: 2px solid rgb(241 241 241);padding: 20px 20px;background: #fff;">
                <div v-if="$isxj"><img src="../assets/home/kefu.png" style="width: 220px;"></div>
                <div v-else><img src="../assets/home/kefuc.png" style="width: 220px;"></div>
                <div style="margin-left: 20px;">
                    <div style="font-size: 30px;">微信扫码</div>
                    <div style="font-size: 28px;color: #999;margin-top: 50px;">联系企业微信客服</div>
                </div>
            </div>
        </div>
        <div><img src="../assets/home/kefub.png" class="kefub" @mouseenter="iskefu = true" @mouseleave="iskefu = false"
                :style="{ bottom: ispc ? '259px' : '50%' }"
                style="width: 50px;height: 50px;position: fixed;right: 0px;cursor: pointer;z-index: 99999999;border-radius: 5px;">
        </div>
    </div>
</template>
<script>
import { getJsonTree } from '@/utils/index'
export default {
    data() {
        return {
            ispc: true,
            action: window['pathConfig'][process.env.NODE_ENV].ImgURL,
            logo: require("@/assets/logo.png"),
            logob: require("@/assets/logob.png"),
            logoc: require("@/assets/logoc.png"),
            logod: require("@/assets/logod.png"),
            currentPath: '/home',
            pmenu: [],
            apps: [],
            menus: [],
            WBmenus: [
                { icon: require("@/assets/hometo/nav1@2x.png"), title: '产品定位' },
                { icon: require("@/assets/hometo/nav2@2x.png"), title: '产品形态' },
                { icon: require("@/assets/hometo/nav3@2x.png"), title: '核心能力' },
                { icon: require("@/assets/hometo/nav4@2x.png"), title: '热门应用场景' },
                { icon: require("@/assets/hometo/nav5@2x.png"), title: '行业应用案例' },
                { icon: require("@/assets/hometo/nav6@2x.png"), title: '岗位价值' },
                { icon: require("@/assets/hometo/nav7@2x.png"), title: '产品版本与定价' },
            ],
            AImenus: [
                { icon: require("@/assets/home/ai11@2x@2x.png"), title: 'AI智能体中台' },
                { icon: require("@/assets/home/ai5@2x.png"), title: 'AI舆情监测' },
                { icon: require("@/assets/home/ai@2x.png"), title: '智慧财务服务助手' },
                { icon: require("@/assets/home/ai1@2x.png"), title: 'AI知识库' },
                { icon: require("@/assets/home/ai2@2x.png"), title: 'AI智能客服' },
                { icon: require("@/assets/home/ai4@2x.png"), title: '智能安防AI预警' },
                { icon: require("@/assets/home/ai6@2x.png"), title: '智能运维接管' },
                { icon: require("@/assets/home/ai7@2x.png"), title: '网络日志智能报表' },
                { icon: require("@/assets/home/ai8@2x.png"), title: '招投标肋手' },
                { icon: require("@/assets/home/ai9@2x.png"), title: '施工技术方案智能审核平台' }
            ],
            istrue: true,
            iskefu: false,
            bindex: -1,
            navItems: [
                { text: '首页', href: '/home' },
                { text: 'AI应用', href: '/AIMenu', isshow: false },
                { text: '标准产品', href: '/product', isshow: false },
                { text: '定制应用', href: '/app', isshow: false },
                { text: 'WorkBuddy', href: '/WorkBuddy', isshow: false },
                { text: '行业解决方案', href: '/solution', isshow: false },
                { text: '客户案例', href: '/crmcase' },
                { text: '关于我们', href: '/aboutus' },
            ],
            // list: [
            //     "腾讯会议",
            //     "腾讯云",
            //     "企业微信",
            //     "腾讯乐享",
            //     "电子签",
            //     "腾讯文档",
            //     "企业网盘",
            //     "腾讯问卷",
            //     "腾讯微卡",
            //     "腾讯云联络中心",
            // ],
            siteConfig: {
                // 标题
                title: "武汉讯捷信息技术有限公司",
                // 图标
                icon: require("@/assets/logo.png"),
                // 副标题
                subTitle: "腾讯授权服务商",
                // 描述
                // description:
                //     "讯捷官方网站 - 我们是一家面向全国提供IT解决方案与服务的公司。 提供腾讯企业产品落地方案，为客户打通各种应用场景，提供咨询、规划、项目开发、系统集成、实施建设、运营推广、售后维护的综合性解决方案提供商。 ",
                // // 关键词
                // keywords:
                //     "讯捷, 技术服务, 软件开发, 数字化转型, 腾讯企业产品, 解决方案, 系统集成, 实施建设, 运营推广, 售后维护",
                // 口号
                slogan: "平台 + 产品 + 服务 = 用户价值",
                // 联系方式
                contact: {
                    phone: "027-87860160",
                    address: "公司地址：湖北省武汉市洪山区书城路维佳创意大厦西区",
                },
                footer: {
                    background: require("@/assets/images/footer.jpg"),
                    copyright: "武汉讯捷信息技术有限公司 版权所有",
                    icp: "鄂ICP备14010542号-1",
                    icpLink: "https://beian.miit.gov.cn/",
                    gajLink:
                        "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42010602000117",
                    gaj: "鄂公网安备 42011102002084号",
                }
            },
            imgs: [require("@/assets/logo/tub1.png"), require("@/assets/logo/tub2.png"), require("@/assets/logo/tub3.png"), require("@/assets/logo/tub4.png"), require("@/assets/logo/tub5.png"), require("@/assets/logo/tub6.png"), require("@/assets/logo/tub7.png"), require("@/assets/logo/tub8.png")]
        }
    },
    created() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.ispc = false
        }
        if (!this.$isxj) {
            this.siteConfig.title = '北京畅邮空间信息技术有限公司'
            this.siteConfig.contact.address = '公司地址：北京市丰台区马家堡西路15号时代风帆大厦'
            this.siteConfig.contact.phone = '400-056-0650'
            this.siteConfig.footer.icp = '京ICP备16025940号'
            // this.siteConfig.footer.gaj = '京ICP备16025940号'
            this.siteConfig.footer.copyright = '北京畅邮空间信息技术有限公司 版权所有'
        }
        this.currentPath = this.$route.path
        //产品
        this.$http('/Product/GetTypeData').then(x => {
            if (x.data.length > 0) {
                var data = getJsonTree(x.data, '', 'pid')
                data.forEach(z => {
                    z.children.forEach(w => {
                        if (w.name == '不要删') w.name = '自研产品'
                        this.pmenu.push(w)
                    })
                })
            }
        })
        //应用
        this.$http('/App/GetTypeData').then(x => {
            if (x.data.length > 0) {
                var data = getJsonTree(x.data, '', 'pid')
                this.apps = data
            }
        })
        //解决方案
        this.$http('/Plan/GetTypeData').then(x => {
            if (x.data.length > 0) {
                this.menus = x.data.filter(z => z.name != '央企' && z.name != '国企')
            }
        })
    },
    methods: {
        mou(i) {
            this.navItems.forEach(x => x.isshow = false)
            // if (this.currentPath != this.navItems[i].href)
            this.navItems[i].isshow = true
            this.bindex = i
        },
        moub(i) {
            this.navItems[i].isshow = false
            this.bindex = -1
        },
        mouc() {
            this.navItems.forEach(x => x.isshow = false)
        },
        to(path) {
            if (path != '/product' && path != '/app' && path != '/solution') {
                this.navItems.forEach(x => x.isshow = false)
                this.currentPath = path
                this.$router.push(path)
            }
        },
        tob(name, ID, index) {
            this.navItems.forEach(x => x.isshow = false)
            if (name == 'solution') {
                this.$router.push({ name: name, query: { index: index } })
            } else if (name == 'WorkBuddy') {
                this.$router.push({ name: name, query: { targetId: ID + 1 } })
            }
            else
                this.$router.push({ name: name, query: { id: ID } })
            if (this.currentPath == '/' + name)
                location.reload()
        }
    },
    watch: {
        $route() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
            document.body.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
            this.currentPath = this.$route.path
            this.bindex = -1
        }
    }
}
</script>
<style>
@keyframes asdzxc {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.asdzxc-enter-active {
    animation: asdzxc 0.5s ease-in-out;
}

.asdzxc-leave-active {
    animation: asdzxc 0.5s ease-in-out reverse;
}

footer {
    --color-primary: #1e66d1;
}

.header-nav-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    font-size: 16px;
    transition: color 0.3s ease-in-out;
    cursor: pointer;
    padding: 0px 13px 0px 13px;
    margin: 0px 4px;
}

.header-nav-item:hover {
    color: var(--color-primary);
}

.header-nav-item.active {
    color: var(--color-primary);
    font-size: 16px;
    font-weight: bold;
}

#hmenu .pmenu {
    border: 1px solid transparent;
}

#hmenu .pmenu:hover {
    border: 1px solid #1e66d1;
    color: #1e66d1;
    background: #edf3fb;
}

.header-li-item:hover {
    border-bottom: 3px solid #1e66d1 !important;
}

.asdzxcas {
    border-bottom: 3px solid #1e66d1 !important;
}

.kefub:hover {
    /* box-shadow:none !important; */
}

.cyaddress {
    margin-top: 25px;
}

.widthaaa {
    width: 250px;
}
</style>